import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { GoogleAuthProvider } from "firebase/auth";

export const firebaseConfig = {
  apiKey: "AIzaSyDXMohvM9k5J9QNCOu65O-ihMAwwkPBaws",
  authDomain: "bar-buzz-a6645.firebaseapp.com",
  projectId: "bar-buzz-a6645",
  storageBucket: "bar-buzz-a6645.firebasestorage.app", // ✅ fixed
  messagingSenderId: "198740108664",
  appId: "1:198740108664:web:58dfbbb18dfac1e0f6548d",
  measurementId: "G-LVSB8PR6SZ"
};




const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

